module.exports = {
    siteUrl: `https://earthspeakr.art`,
    sitemapPath: "/sitemap.xml"
};
